<template>
    <div class="py-20 px-6 space-y-10">
      <div class="flex w-full justify-center items-center text-ihh-midnight-gray font-semibold text-4xl text-center">Custom Birth Kits by Midwife</div>
      <div class="flex w-full justify-center items-center text-ihh-slate-gray font-semibold text-base text-center">Please use the search box below to find your midwife's kit under her name or midwifery practice name.</div>
      <div class="flex w-full justify-center">
        <div class="flex flex-col w-full max-w-md justify-center gap-y-4 ">
          <div class="flex w-full border border-ihh-slate-gray rounded overflow-hidden group">
            <input
              type="text"
              id="name"
              v-model="name"
              required
              class="focus:outline-0 px-3 bg-ihh-white w-full text-sm md:text-base font-light text-black placeholder-ihh-gray relative"
              placeholder="Type here..."
            />
            <button class="duration-300 transition ease-in-out bg-ihh-white hover:bg-ihh-salmon/40 right-0 p-3 border-l border-ihh-slate-gray" @click="searchBarOpen">
            <img
              src="/images/ob-search0129.svg"
              class="w-6 h-6 duration-300 transition ease-in-out"
              alt="Search Icon"
            />
          </button>
          </div>
          <button class="text-sm md:text-base text-ihh-midnight-gray py-3 px-10 rounded-lg bg-ihh-dark-salmon hover:bg-ihh-salmon delay-100 transition tracking-wide font-semibold shadow-md">Search Custom Birth Kits</button>
        </div>
      </div>

      <FilteredSearch />

    </div>
</template>


<script>
import FilteredSearch from './ihh-items/filtered-search.vue';
export default {
  components: { FilteredSearch },
    data() {
        return {
            name: '',
        }
    },
    method: {
        searchBarOpen() {
            return this.name;
        }
    },
    computed: {

    }
}
</script>
